export const setPhoneNumber = (data: string) => {
    return {
        type: SET_PHONE_NUMBER,
        payload: data,
    };
};

export const setPhoneAbroad = (data: string) => {
    return {
        type: SET_PHONE_ABROAD,
        payload: data,
    };
};

export const setSmsLink = (data: string) => {
    return {
        type: SET_SMS_LINK,
        payload: data,
    };
};

export const setServiceHoursCenterServices = (data: string) => {
    return {
        type: SET_SERVICE_HOURS_PHONE_ARABIC,
        payload: data,
    };
};

export const setServiceHoursPhoneArabic = (data: string) => {
    return {
        type: SET_SERVICE_HOURS_PHONE_ARABIC,
        payload: data,
    };
};

export const setAudienceReception = (data: string) => {
    return {
        type: SET_AUDIENCE_RECEPTION,
        payload: data,
    };
};

export const setAudienceReceptionArabic = (data: string) => {
    return {
        type: SET_AUDIENCE_RECEPTION_ARABIC,
        payload: data,
    };
};


export const setEmail = (data: string) => {
    return {
        type: SET_EMAIL,
        payload: data,
    };
};


export const setFaxNumber = (data: string) => {
    return {
        type: SET_FAX_NUMBER,
        payload: data,
    };
};

export const setServiceHoursPhone = (data: string) => {
    return {
        type: SET_SERVICE_HOURS_PHONE,
        payload: data,
    };
};



export const setServiceHoursCenterServicesArabic = (data: string) => {
    return {
        type: SET_SERVICE_HOURS_CENTER_SERVICES_ARABIC,
        payload: data,
    };
};

export const setsServiceHoursCenterServices = (data: string) => {
    return {
        type: SET_SERVICE_HOURS_CENTER_SERVICES,
        payload: data,
    };
};

export const SET_PHONE_NUMBER = "phoneNumber";
export const SET_PHONE_ABROAD = "phoneAbroad";
export const SET_SMS_LINK = "smsLink";
export const SET_SERVICE_HOURS_PHONE_ARABIC = "serviceHoursPhoneArabic";
export const SET_SERVICE_HOURS_PHONE = "serviceHoursPhone";
export const SET_AUDIENCE_RECEPTION = "audienceReception";
export const SET_AUDIENCE_RECEPTION_ARABIC = "audienceReceptionArabic";
export const SET_EMAIL = "email";
export const SET_FAX_NUMBER = "faxNumber";
export const SET_SERVICE_HOURS_CENTER_SERVICES = "serviceHoursCenterServices";
export const SET_SERVICE_HOURS_CENTER_SERVICES_ARABIC = "serviceHoursCenterServicesArabic";
